import React from "react";
import "./Sidebar.css";
import SidebarWidgets from "./SidebarWidgets";
import HomeIcon from "@mui/icons-material/Home";
import CreditCardIcon from "@mui/icons-material/CreditCard";
import PaymentsOutlinedIcon from "@mui/icons-material/PaymentsOutlined";
import MonetizationOnOutlinedIcon from "@mui/icons-material/MonetizationOnOutlined";
import CurrencyExchangeOutlinedIcon from "@mui/icons-material/CurrencyExchangeOutlined";
import SavingsOutlinedIcon from "@mui/icons-material/SavingsOutlined";
import LocalOfferOutlinedIcon from "@mui/icons-material/LocalOfferOutlined";
import ForumOutlinedIcon from "@mui/icons-material/ForumOutlined";
import SupportAgentOutlinedIcon from "@mui/icons-material/SupportAgentOutlined";
import SettingsOutlinedIcon from "@mui/icons-material/SettingsOutlined";

const Sidebar = () => {
  return (
    <div className="bg-[#008556] flex-col flex rounded-lg ml-1 mt-1 sidebar">
      <SidebarWidgets title="Home" Icon={HomeIcon} activeTab="true" />
      <SidebarWidgets title="Account" Icon={MonetizationOnOutlinedIcon} />
      <SidebarWidgets title="Cards" Icon={CreditCardIcon} />
      <SidebarWidgets title="Payments" Icon={PaymentsOutlinedIcon} />
      <SidebarWidgets title="Transfer" Icon={CurrencyExchangeOutlinedIcon} />
      <SidebarWidgets title="Savings" Icon={SavingsOutlinedIcon} />
      <SidebarWidgets title="Offers" Icon={LocalOfferOutlinedIcon} />
      <SidebarWidgets title="Messages" Icon={ForumOutlinedIcon} />
      <SidebarWidgets title="Support" Icon={SupportAgentOutlinedIcon} />
      <SidebarWidgets title="Settings" Icon={SettingsOutlinedIcon} />
    </div>
  );
};

export default Sidebar;
